import { hasFIFailuresEnhancementTrmnt } from '../../experiments/fiFailuresEnhancement'
import { SEND_MONEY_ERRORS } from '../constants'

/**
 * @NOTE INSTRUMENT_DEBIT_FAILED VS INSTRUMENT_DECLINED
 *  The first one is an error code thrown at fulfillment when the selected
 *  funding instrument was declined by the issuer, while the second one is a
 *  tag that is added by P2P Services to a funding source after it was declined.
 */
export function isInstrumentDebitFailedError(err) {
  return (
    hasFIFailuresEnhancementTrmnt() &&
    err &&
    err.code === SEND_MONEY_ERRORS.INSTRUMENT_DEBIT_FAILED
  )
}
